import Swal from 'sweetalert2/dist/sweetalert2'
import i18n from '@/i18n'

const { t } = i18n.global

export const toast_success = function (msg) {
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: 'success',
    title: t('toast.system_prompt'),
    text: msg,
  })
}

export const toast_error = function (msg) {
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: 'error',
    title: t('toast.system_prompt'),
    text: msg,
  })
}

export const toast_warning = function (msg) {
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: 'warning',
    title: t('toast.system_prompt'),
    text: msg,
  })
}
